import { LanguageCodeType } from '@/localization';

import catalan from '@/assets/icons/countries/CAT.webp';
import spain from '@/assets/icons/countries/ESP.png';
import EST from '@/assets/icons/countries/EST.svg';
import FRN from '@/assets/icons/countries/FRN.png';
import GBR from '@/assets/icons/countries/GBR.svg';
import LAT from '@/assets/icons/countries/LAT.svg';
import RUS from '@/assets/icons/countries/RUS.png';
import SVK from '@/assets/icons/countries/SVK.svg';

export const countryFlagByCode = (code: LanguageCodeType) => {
  const flag = {
    es: EST,
    lt: LAT,
    sl: SVK,
    rus: RUS,
    fr: FRN,
    en: GBR,
    sp: spain,
    ca: catalan,
  };
  return flag[code.toLowerCase() as keyof typeof flag] || GBR;
};
